import { useEffect, useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import Footer from "../common/Footer";
import Header from "../common/Header";

const styles = {
    Heading: {
        color: "black"
    },
    modelDiv1: {
        backgroundColor: "rgba(0, 0, 0, 0.5)",
    },
}

function Images() {

    const apiURL = process.env.REACT_APP_API_URL

    const [Adata, setAData] = useState([]);
    const [AImage, setAImage] = useState("");

    const [model, setModel] = useState(false);

    useEffect(() => {
        fetchFn();
    }, [])

    function modelFn(img) {
        setModel(true);
        setAImage(img);
    }

    function fetchFn() {
        fetch(`${apiURL}/user/fetchAImage`).then((result) => {
            return result.json();
        }).then((data) => {
            if (data.status === 200) {
                setAData(data.data);
            } else {
                toast(data.message, { type: "error" });
            }
        })
    }

    return (
        <>
            <ToastContainer />
            <Header />
            <section id="image-page">
                <div className="container">
                    <div className="row">
                        <div className="col-sm-12 my-sm-5 my-4">
                            <p style={styles.Heading} className="text-center d-sm-block d-none font-family fw-bolder heading m-0">ALL IMAGES</p>
                            <p style={styles.Heading} className="text-center d-sm-none d-block font-family fw-bolder fs-3 m-0">ALL IMAGES</p>
                        </div>
                    </div>
                </div>
                <div className="container mb-3">
                    <div className="row">
                        {Adata.map((data, key) => (
                            <div key={data._id} className="col-sm-4 col-12 p-2">
                                <div onClick={() => { modelFn(data.AImage) }} className="d-sm-block d-none">
                                    <img src={data.AImage} alt="Not found" />
                                </div>
                                <div className="d-sm-none d-block">
                                    <img src={data.AImage} alt="Not found" />
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
            <Footer />

            {model ? (
                <>
                    <section style={styles.modelDiv1} id="model" className="overflow-auto" >
                        <div className="container">
                            <div className="row mt-5">
                                <div className="col-sm-2">
                                </div>
                                <div className="col-sm-8 mt-0 p-0">
                                    <img src={AImage} alt="Not found" />
                                </div>
                                <div className="col-sm-1 mt-0">
                                    <img onClick={() => { setModel(false) }} src="media/close.png" alt="Not found" />
                                </div>
                                <div className="col-sm-1">
                                </div>
                            </div>
                        </div>
                    </section>
                </>
            ) : (
                <></>
            )}

        </>
    );
}

export default Images;